module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('calendar', {
    attrs: {
      "view": _vm.view,
      "decorate": _vm.decorate,
      "sub": _vm.sub,
      "selected": _vm.selected,
      "current-view": _vm.currentView,
      "start-date": _vm.startDate,
      "indicator": _vm.indicator,
      "start-monday": true
    },
    on: {
      "prev": _vm.prev,
      "next": _vm.next,
      "today": _vm.today,
      "onPropsChange": _vm.change
    }
  }, [_c('div', {
    staticClass: "actions",
    slot: "action"
  }, [_c('div', {
    staticClass: "action",
    on: {
      "click": _vm.changeView
    }
  }, [_vm._v(_vm._s(_vm.viewName))]), _vm._v(" "), _c('div', {
    staticClass: "action",
    on: {
      "click": _vm.addEvent
    }
  }, [_vm._v("加")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-92603ff8!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/calendar-demo.vue
// module id = 126
// module chunks = 0